var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiceD4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 309.072C512 302.022 509.671 294.919 504.862 289L280.874 11.875C274.499 4 265.249 0 256 0C246.75 0 237.501 4 231.126 11.875L7.138 289C2.329 294.919 0 302.022 0 309.072C0 318.697 4.341 328.223 12.638 334.5L236.626 505.5C242.126 509.75 249 512 256 512C262.875 512 269.624 509.875 275.374 505.5L499.362 334.5C507.659 328.223 512 318.697 512 309.072ZM232.001 87.125V441.5L54.76 306.375L232.001 87.125ZM279.999 441.5V87.125L457.24 306.375L279.999 441.5Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceD4);
export default __webpack_public_path__ + "static/media/dice-d4.b3ffe71e321764c6f348d8364821b47e.svg";
export { ForwardRef as ReactComponent };